import React, { useContext } from 'react'
import { Link, navigate } from 'gatsby'
import { UserDataContext } from '@context/userContext'
import { BuyDataContext } from '@context/buyContext'

import ButtonSuccess from '@components/buttons/ButtonSuccess'

import { RiDeleteBin6Line } from 'react-icons/ri'
import { text_lg } from '@constant/colors'

const Drawer = () => {
  const userData = useContext(UserDataContext)
  const buyData = useContext(BuyDataContext)
  const { drawerCart, setDrawerCart } = userData
  const {
    products,
    setDeleteProduct,
    setAmountPlus,
    setAmountMinus,
    setDelivery,
    setPayment
  } = buyData
  const { total_precio } = buyData.payment

  const handleCart = () => {
    setDelivery({
      tipoDelivery: '',
      guardadoDeliveryTime: false
    })
    setPayment({
      singleProduct: false,
      precioEscogido: 0,
      disablePayment: true,
      cupon: {
        id: '',
        monto_descuento: 0,
        codigo_cupon: ''
      }
    })
    setDrawerCart(!drawerCart)
    return navigate('/detalle/' + 'all' + '/pago/')
  }

  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center">
      <span
        className="absolute left-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-white text-lg font-semibold shadow-sm drop-shadow-sm transition-all hover:bg-lime-200"
        onClick={() => setDrawerCart(!drawerCart)}
      >
        X
      </span>
      <span className="py-6 text-xl font-semibold">Carrito</span>
      <div
        className={`flex h-full w-full flex-grow flex-col items-center ${
          products.length === 0 ? 'justify-center' : 'justify-start'
        } gap-4 overflow-y-auto px-5`}
      >
        {products.length === 0 && (
          <div className="flex flex-col items-center justify-center gap-2">
            <span className="text-2xl font-semibold">No hay detalles</span>
          </div>
        )}

        {products.map(product => (
          <div className="card card-side w-full bg-base-100 shadow-lg" key={product.id}>
            <img
              src={product.url_imagen}
              alt="Movie"
              className="flex h-full w-40 overflow-hidden rounded-bl-2xl rounded-tl-2xl object-cover xs:w-52"
            />
            <div className="flex w-full flex-col justify-between px-4 py-2 xxs:py-4">
              <div className="flex flex-row items-start justify-between">
                <div className="flex h-full flex-col items-start justify-between pr-2">
                  <p className="line-clamp-3 w-full text-[10px] xs:text-[12px] lg:text-[14px]">
                    {product.descripcion}
                  </p>
                  <span className=" pt-2 text-[10px] xs:text-[12px] lg:text-[14px]">
                    Precio unitario:{' '}
                    <span className="font-semibold"> s/ {product.precio}.00</span>
                  </span>
                </div>
                <button
                  className="btn btn-circle btn-error btn-xs xs:btn-sm"
                  onClick={() => {
                    setDeleteProduct(product.id)
                  }}
                >
                  <RiDeleteBin6Line size={text_lg} />
                </button>
              </div>
              <div className="card-actions items-center justify-between">
                <div className="flex flex-row items-center gap-1 rounded-full border border-green-500 bg-green-100 p-1 ">
                  <button
                    className="btn btn-circle btn-success btn-xs text-sm text-white"
                    onClick={() => {
                      setAmountMinus(product.id)
                    }}
                  >
                    -
                  </button>
                  <span className="px-2 font-bold text-green-700">
                    {product.cantidad}
                  </span>
                  <button
                    className="btn btn-circle btn-success btn-xs text-sm text-white"
                    onClick={() => {
                      setAmountPlus(product.id)
                    }}
                  >
                    +
                  </button>
                </div>
                <span className="text-[14px] font-semibold">
                  s/ {product.precio * product.cantidad}.00
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      {products.length > 0 && (
        <div className="flex h-52 w-full flex-col items-center justify-center gap-2 px-8">
          <div className="flex w-full flex-row items-center justify-between">
            <span className="text-lg font-semibold">Total a pagar</span>
            <span className="text-[14px]">
              s/ <span className="font-semibold">{total_precio}.00</span>
            </span>
          </div>
          <ButtonSuccess text={'Comprar ahora'} onClick={() => handleCart()} />
        </div>
      )}
    </div>
  )
}

export default Drawer

